<template>
    <footer>
        Copyright © {{data.year}} Medellín - Colombia Gerencia de Ingeniería y Desarrollo Emtelco S.A.S
    </footer>
</template>

<script>
import Config from '@/config'

export default {
    name: 'emt-footer',
    data: function () {
        return {
            data: {
                year: Config.year
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// emt-footer.vue?3ef32ed0